// Shared referral code utility — available globally on every page via the header snippet.
// Reads the code stored by the endota-booking-referral section and appends it to booking URLs.
window.EndotaReferral = (function () {
  var STORAGE_KEY = 'endota_booking_referral_code';

  function getCode() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (Date.now() > parsed.expiry) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return parsed.value;
    } catch (e) {
      return null;
    }
  }

  function appendToUrl(url, paramName) {
    if (!url || !paramName) return url;
    var code = getCode();
    if (!code) return url;
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + encodeURIComponent(paramName) + '=' + encodeURIComponent(code);
  }

  return { getCode: getCode, appendToUrl: appendToUrl };
})();
